import React from 'react'
import PropTypes from 'prop-types'
import {
  Typography,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from '@material-ui/core'

import { BaseDialog } from 'components'
import { Controller, useForm } from 'react-hook-form'

import schema from './schema'

const ExportRopaDialog = ({ open, onClose, onSubmit }) => {
  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      fileType: '',
    },
  })

  return (
    <BaseDialog
      open={open}
      setOpen={onClose}
      title="Escolha o Formato do Relatório"
      dialogSize="sm"
      fullWidth
      closeButtonText="Cancelar"
      actionButtonText="Confirmar"
      actionButton={handleSubmit(onSubmit)}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            name="fileType"
            control={control}
            defaultValue=""
            as={
              <RadioGroup row name="fileType">
                <FormControlLabel
                  value="pdf"
                  control={<Radio color="primary" />}
                  label="PDF"
                />
                <FormControlLabel
                  value="xlsx"
                  control={<Radio color="primary" />}
                  label="XLSX (Planilha)"
                />
              </RadioGroup>
            }
          />
          {errors?.fileType && (
            <Typography color="error">{errors.fileType.message}</Typography>
          )}
        </Grid>
      </Grid>
    </BaseDialog>
  )
}

ExportRopaDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ExportRopaDialog
